"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8388],{

/***/ 57686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ Assets; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-FAWTVNS3.mjs
var chunk_FAWTVNS3 = __webpack_require__(27239);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-DFWC5MHP.mjs
var chunk_DFWC5MHP = __webpack_require__(85970);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 2 modules
var chunk_ZHMYA64R = __webpack_require__(55281);
// EXTERNAL MODULE: ./src/hooks/useDcaInForm.ts
var useDcaInForm = __webpack_require__(41393);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(5380);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/hooks/useValidation.ts
var useValidation = __webpack_require__(62235);
// EXTERNAL MODULE: ./src/hooks/useBalances.ts
var useBalances = __webpack_require__(52560);
// EXTERNAL MODULE: ./src/components/ModalWrapper.tsx
var ModalWrapper = __webpack_require__(21183);
// EXTERNAL MODULE: ./src/models/StrategyType.tsx
var StrategyType = __webpack_require__(94705);
// EXTERNAL MODULE: ./src/components/Spinner/index.tsx
var Spinner = __webpack_require__(12376);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chunk-Q56JAA3U.mjs
var chunk_Q56JAA3U = __webpack_require__(20307);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-NTCQBYKE.mjs
var chunk_NTCQBYKE = __webpack_require__(48783);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3ASUQ6PA.mjs
var chunk_3ASUQ6PA = __webpack_require__(34292);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chunk-2WQJ2JCV.mjs
var chunk_2WQJ2JCV = __webpack_require__(58972);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-PULVB27S.mjs
var chunk_PULVB27S = __webpack_require__(57747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AssetsPageAndForm/AssetPageStrategyButtons/StrategyRadioCard.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function StrategyRadioCard(_ref) {
  var props = _extends({}, _ref);

  var _useRadio = (0,chunk_2WQJ2JCV/* useRadio */.x)(props),
      getInputProps = _useRadio.getInputProps,
      getRadioProps = _useRadio.getRadioProps;

  var input = getInputProps();
  var checkbox = getRadioProps();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_PULVB27S/* Box */.xu, {
    as: "label",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({}, input)), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, _objectSpread(_objectSpread({}, checkbox), {}, {
      cursor: "pointer",
      borderWidth: 1,
      borderRadius: "lg",
      textColor: "slategrey",
      borderColor: "slategrey",
      _checked: {
        color: 'blue.200',
        borderColor: 'blue.200'
      },
      _hover: {
        bgColor: 'transparent'
      },
      fontSize: {
        base: '10px',
        sm: '12px'
      },
      width: {
        base: '108px',
        sm: 32
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_PULVB27S/* Box */.xu, {
            children: [" ", props.children]
          })
        })
      })
    }))]
  });
}
// EXTERNAL MODULE: ./src/components/AssetsPageAndForm/AssetPageStrategyButtons/index.tsx
var AssetPageStrategyButtons = __webpack_require__(88070);
// EXTERNAL MODULE: ./src/components/AssetsPageAndForm/AssetPageStrategyButtons/DcaCategory.tsx
var DcaCategory = __webpack_require__(2581);
;// CONCATENATED MODULE: ./src/components/CategoryAndStrategyButtonSelectors.tsx



function CategoryAndStrategyButtonSelectors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CategoryAndStrategyButtonSelectors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CategoryAndStrategyButtonSelectors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CategoryAndStrategyButtonSelectors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var categoryButtonOptions = [DcaCategory/* DcaDirection.Buy */.z.Buy, DcaCategory/* DcaDirection.Sell */.z.Sell];
var strategyButtonOptions = {
  "in": [StrategyType/* StrategyType.DCAIn */.h.DCAIn, StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn, StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn],
  out: [StrategyType/* StrategyType.DCAOut */.h.DCAOut, StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut, StrategyType/* StrategyType.WeightedScaleOut */.h.WeightedScaleOut]
};
function CategoryAndStrategyButtonSelectors() {
  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'strategyType'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      strategyType = _useField2[0],
      helpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 3),
      initialDenomHelpers = _useField4[2];

  var _useField5 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField6 = (0,slicedToArray/* default */.Z)(_useField5, 3),
      initialDeposit = _useField6[0],
      initialDepositHelpers = _useField6[2];

  var _useField7 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField8 = (0,slicedToArray/* default */.Z)(_useField7, 3),
      resultingDenomHelpers = _useField8[2];

  var direction = strategyButtonOptions["in"].includes(strategyType.value) ? DcaCategory/* DcaDirection.Buy */.z.Buy : DcaCategory/* DcaDirection.Sell */.z.Sell;

  var _useState = (0,react.useState)(direction),
      selectedDirection = _useState[0],
      setSelectedDirection = _useState[1];

  var updateStrategyType = function updateStrategyType(type) {
    initialDenomHelpers.setValue('');
    initialDenomHelpers.setTouched(false);
    resultingDenomHelpers.setValue('');
    resultingDenomHelpers.setTouched(false);
    initialDepositHelpers.setValue(initialDeposit.value);
    initialDepositHelpers.setTouched(false);
    helpers.setValue(type);
  };

  var updateDcaDirection = function updateDcaDirection(category) {
    updateStrategyType(category === DcaCategory/* DcaDirection.Buy */.z.Buy ? StrategyType/* StrategyType.DCAIn */.h.DCAIn : StrategyType/* StrategyType.DCAOut */.h.DCAOut);
    setSelectedDirection(category);
  };

  var _useRadioGroup = (0,chunk_Q56JAA3U/* useRadioGroup */.a)({
    name: 'category',
    defaultValue: selectedDirection,
    onChange: updateDcaDirection
  }),
      getCategoryRootProps = _useRadioGroup.getRootProps,
      getRadioProps = _useRadioGroup.getRadioProps;

  var _useRadioGroup2 = (0,chunk_Q56JAA3U/* useRadioGroup */.a)({
    name: 'strategy',
    defaultValue: strategyType.value,
    value: strategyType.value,
    onChange: updateStrategyType
  }),
      getStrategyRootProps = _useRadioGroup2.getRootProps,
      getStrategyRadioProps = _useRadioGroup2.getRadioProps;

  var strategyGroup = getStrategyRootProps();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_NTCQBYKE/* VStack */.g, {
    spacing: 4,
    pb: 6,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, getCategoryRootProps()), {}, {
      spacing: {
        base: 4,
        sm: 8
      },
      children: categoryButtonOptions.map(function (value) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(AssetPageStrategyButtons/* CategoryRadioCard */.fV, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, getRadioProps({
          value: value
        })), {}, {
          buttonClicked: selectedDirection,
          children: value
        }), value);
      })
    })), selectedDirection === DcaCategory/* DcaDirection.Buy */.z.Buy ? /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, strategyGroup), {}, {
      spacing: {
        base: 1,
        sm: 2
      },
      children: strategyButtonOptions["in"].map(function (value) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StrategyRadioCard, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, getStrategyRadioProps({
          value: value,
          isChecked: strategyType.value === value
        })), {}, {
          children: value
        }), value);
      })
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, strategyGroup), {}, {
      spacing: {
        base: 1,
        sm: 2
      },
      children: strategyButtonOptions.out.map(function (value) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StrategyRadioCard, CategoryAndStrategyButtonSelectors_objectSpread(CategoryAndStrategyButtonSelectors_objectSpread({}, getStrategyRadioProps({
          value: value,
          isChecked: strategyType.value === value
        })), {}, {
          children: value
        }), value);
      })
    }))]
  });
}
// EXTERNAL MODULE: ./src/hooks/useFormStore.ts
var useFormStore = __webpack_require__(48403);
// EXTERNAL MODULE: ./src/helpers/routerPush.ts
var routerPush = __webpack_require__(64485);
// EXTERNAL MODULE: ./src/formConfig/dcaIn.tsx + 1 modules
var dcaIn = __webpack_require__(75141);
// EXTERNAL MODULE: ./src/formConfig/dcaOut.tsx
var dcaOut = __webpack_require__(73860);
// EXTERNAL MODULE: ./src/formConfig/dcaPlusIn.tsx
var dcaPlusIn = __webpack_require__(17120);
// EXTERNAL MODULE: ./src/formConfig/dcaPlusOut.tsx
var dcaPlusOut = __webpack_require__(39706);
// EXTERNAL MODULE: ./src/formConfig/simpleDcaIn.tsx
var simpleDcaIn = __webpack_require__(2248);
// EXTERNAL MODULE: ./src/formConfig/streamingSwap.tsx
var streamingSwap = __webpack_require__(37154);
// EXTERNAL MODULE: ./src/formConfig/weightedScaleIn.tsx
var weightedScaleIn = __webpack_require__(79359);
// EXTERNAL MODULE: ./src/formConfig/weightedScaleOut.tsx
var weightedScaleOut = __webpack_require__(34010);
;// CONCATENATED MODULE: ./src/helpers/assets-page/getSteps.tsx


var _stepsByStrategyType;










var stepsByStrategyType = (_stepsByStrategyType = {}, (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.SimpleDCAIn */.h.SimpleDCAIn, simpleDcaIn/* default */.Z), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.DCAIn */.h.DCAIn, dcaIn/* default */.Z), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.DCAOut */.h.DCAOut, dcaOut/* default */.Z), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn, dcaPlusIn/* dcaPlusInSteps */.F), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut, dcaPlusOut/* default */.Z), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn, weightedScaleIn/* weightedScaleInSteps */.U), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.WeightedScaleOut */.h.WeightedScaleOut, weightedScaleOut/* default */.Z), (0,defineProperty/* default */.Z)(_stepsByStrategyType, StrategyType/* StrategyType.StreamingSwap */.h.StreamingSwap, streamingSwap/* default */.Z), _stepsByStrategyType);
function getSteps(strategySelected) {
  return stepsByStrategyType[strategySelected];
}
// EXTERNAL MODULE: ./src/hooks/useStrategyInfo.tsx
var useStrategyInfo = __webpack_require__(47134);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./src/models/DcaInFormData.ts
var DcaInFormData = __webpack_require__(89601);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-H46NUPBZ.mjs
var chunk_H46NUPBZ = __webpack_require__(5418);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var chunk_2OOHT3W5 = __webpack_require__(71293);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-BL2ZZSHG.mjs
var chunk_BL2ZZSHG = __webpack_require__(65028);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-NEK3OOAM.mjs
var chunk_NEK3OOAM = __webpack_require__(5674);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-VGESXGVT.mjs
var chunk_VGESXGVT = __webpack_require__(26105);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./src/components/AvailableFunds.tsx
var AvailableFunds = __webpack_require__(24497);
// EXTERNAL MODULE: ./src/components/DenomSelect.tsx
var DenomSelect = __webpack_require__(75872);
// EXTERNAL MODULE: ./src/components/InitialDeposit.tsx
var InitialDeposit = __webpack_require__(45435);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/hooks/useDenoms.ts
var useDenoms = __webpack_require__(99867);
// EXTERNAL MODULE: ./node_modules/rambda/src/values.js
var values = __webpack_require__(6285);
// EXTERNAL MODULE: ./src/hooks/useRoute.ts
var useRoute = __webpack_require__(61456);
// EXTERNAL MODULE: ./node_modules/@cosmjs/stargate/build/index.js
var build = __webpack_require__(24658);
// EXTERNAL MODULE: ./src/components/Submit.tsx
var Submit = __webpack_require__(9685);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(47309);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
;// CONCATENATED MODULE: ./src/components/AssetsPageAndForm/AssetsForm/index.tsx
























function getIsDcaInStrategy(strategyType) {
  var strategy = strategyType && strategyType;
  return [StrategyType/* StrategyType.DCAIn */.h.DCAIn, StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn, StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn].includes(strategy);
}

function getInitialDenomsFromStrategyType(strategyType, denoms) {
  if (!strategyType || !denoms) {
    return [];
  }

  return denoms.filter(function (denom) {
    return (getIsDcaInStrategy(strategyType) ? (0,getDenomInfo/* isDenomStable */.dG)(denom) : true) && (strategyType === StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut ? (0,usePairs/* isSupportedDenomForDcaPlus */.wk)(denom) : true) && (strategyType === StrategyType/* StrategyType.DCAOut */.h.DCAOut ? (0,getDenomInfo/* isDenomVolatile */.g1)(denom) : true) && (0,getDenomInfo/* denomHasCoingeckoId */.YC)(denom);
  });
}

function getResultingDenomsFromStrategyType(strategyType, pairs, initialDenom) {
  if (!strategyType || !pairs || !initialDenom) return [];
  var resultingDenoms = (0,usePairs/* getResultingDenoms */.jS)(pairs, initialDenom).filter(function (denom) {
    return denom.id !== initialDenom.id;
  });
  return strategyType === StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn ? resultingDenoms.filter(usePairs/* isSupportedDenomForDcaPlus */.wk) : resultingDenoms;
}

function AssetsForm() {
  var _useWallet = (0,useWallet/* useWallet */.O)(),
      connected = _useWallet.connected;

  var _useDenoms = (0,useDenoms/* default */.Z)(),
      denoms = _useDenoms.denoms;

  var _usePairs = (0,usePairs/* default */.ZP)(),
      pairs = _usePairs.pairs;

  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      initialDenom = _useField2[0].value,
      initialDenomMeta = _useField2[1],
      initialDenomHelpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 1),
      initialDeposit = _useField4[0].value;

  var _useField5 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField6 = (0,slicedToArray/* default */.Z)(_useField5, 3),
      resultingDenom = _useField6[0].value,
      resultingDenomMeta = _useField6[1],
      resultingDenomHelpers = _useField6[2];

  var _useField7 = (0,formik_esm/* useField */.U$)({
    name: 'strategyType'
  }),
      _useField8 = (0,slicedToArray/* default */.Z)(_useField7, 1),
      strategyType = _useField8[0];

  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId;

  var _useDenoms2 = (0,useDenoms/* default */.Z)(),
      getDenomById = _useDenoms2.getDenomById;

  var _useField9 = (0,formik_esm/* useField */.U$)({
    name: 'route'
  }),
      _useField10 = (0,slicedToArray/* default */.Z)(_useField9, 3),
      routeMeta = _useField10[1],
      routeHelpers = _useField10[2];

  var _useRoute = (0,useRoute/* default */.Z)(initialDenom.significantFigures ? (0,build.coin)(BigInt((0,getDenomInfo/* toAtomic */.Iy)(initialDenom, 1)).toString(), initialDenom.id) : undefined, resultingDenom),
      route = _useRoute.route,
      routeError = _useRoute.routeError,
      routeIsLoading = _useRoute.isLoading;

  (0,react.useEffect)(function () {
    if (routeIsLoading) {
      routeHelpers.setValue(undefined);
      routeHelpers.setTouched(false);
    } else if (routeError) {
      routeHelpers.setTouched(true, false);
      routeHelpers.setError(routeError);
    } else {
      routeHelpers.setValue(route);
      routeHelpers.setTouched(true);
    }
  }, [route, routeError, routeIsLoading]);
  if (!pairs || !(denoms !== null && denoms !== void 0 && denoms[chainId])) return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, {
    height: 200,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
      h: "full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    })
  });
  var isDcaInStrategy = getIsDcaInStrategy(strategyType.value);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
      isInvalid: Boolean(initialDenomMeta.touched && initialDenomMeta.error),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
        children: isDcaInStrategy ? 'How will you fund your first investment?' : 'What position do you want to take profit on?'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_FAWTVNS3/* Center */.M, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
            textStyle: "body-xs",
            children: [isDcaInStrategy ? 'Choose stablecoin' : "CALC currently supports pairs trading on ".concat((0,chains/* getChainDexName */.rB)(chainId), "."), ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_BL2ZZSHG/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(AvailableFunds/* AvailableFunds */.jk, {
            denom: initialDenom
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_NEK3OOAM/* SimpleGrid */.M, {
        columns: 2,
        spacing: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_PULVB27S/* Box */.xu, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
            denoms: denoms && chainId && denoms[chainId] ? (0,usePairs/* orderAlphabetically */.t1)(getInitialDenomsFromStrategyType(strategyType.value, (0,values/* values */.V)(denoms[chainId]))) : [],
            placeholder: "Choose\xA0asset",
            value: initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.id,
            onChange: function onChange(v) {
              return v && initialDenomHelpers.setValue(getDenomById(v));
            },
            optionLabel: (0,chains/* getChainDexName */.rB)(chainId)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_VGESXGVT/* FormErrorMessage */.J1, {
            children: initialDenomMeta.touched && initialDenomMeta.error ? typeof initialDenomMeta.error === 'string' ? initialDenomMeta.error : (0,values/* values */.V)(initialDenomMeta.error)[0] : null
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InitialDeposit/* default */.Z, {})]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
      isInvalid: Boolean(resultingDenomMeta.touched && resultingDenomMeta.error) || !!routeMeta.error,
      isDisabled: !initialDenom,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
        hidden: !isDcaInStrategy,
        children: "What asset do you want to invest in?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
        hidden: isDcaInStrategy,
        children: "How do you want to hold your profits?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
          textStyle: "body-xs",
          children: isDcaInStrategy ? 'CALC will purchase this asset for you' : 'You will have the choice to move these funds into another strategy at the end.'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
        denoms: getResultingDenomsFromStrategyType(strategyType.value, pairs, initialDenom),
        placeholder: "Choose asset",
        value: resultingDenom,
        onChange: function onChange(v) {
          return v && resultingDenomHelpers.setValue(getDenomById(v));
        },
        optionLabel: "Swapped on ".concat((0,chains/* getChainDexName */.rB)(chainId))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_VGESXGVT/* FormErrorMessage */.J1, {
        children: (resultingDenomMeta.touched && resultingDenomMeta.error ? typeof resultingDenomMeta.error === 'string' ? resultingDenomMeta.error : (0,values/* values */.V)(resultingDenomMeta.error)[0] : null) || initialDenomMeta.touched && initialDenomMeta.error || routeError
      })]
    }), connected ? /*#__PURE__*/(0,jsx_runtime.jsx)(Submit/* default */.Z, {
      isDisabled: !initialDeposit || !routeMeta.touched || !!routeError,
      children: "Next"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})]
  });
}
;// CONCATENATED MODULE: ./src/components/AssetsPageAndForm/index.tsx


var _strategyTypesToFormT;

function AssetsPageAndForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AssetsPageAndForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AssetsPageAndForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AssetsPageAndForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var strategyTypesToFormTypes = (_strategyTypesToFormT = {}, (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.SimpleDCAIn */.h.SimpleDCAIn, useFormStore/* FormNames.SimpleDcaIn */.Z.SimpleDcaIn), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.DCAIn */.h.DCAIn, useFormStore/* FormNames.DcaIn */.Z.DcaIn), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.DCAOut */.h.DCAOut, useFormStore/* FormNames.DcaOut */.Z.DcaOut), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn, useFormStore/* FormNames.DcaPlusIn */.Z.DcaPlusIn), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut, useFormStore/* FormNames.DcaPlusOut */.Z.DcaPlusOut), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn, useFormStore/* FormNames.WeightedScaleIn */.Z.WeightedScaleIn), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.WeightedScaleOut */.h.WeightedScaleOut, useFormStore/* FormNames.WeightedScaleOut */.Z.WeightedScaleOut), (0,defineProperty/* default */.Z)(_strategyTypesToFormT, StrategyType/* StrategyType.StreamingSwap */.h.StreamingSwap, useFormStore/* FormNames.StreamingSwap */.Z.StreamingSwap), _strategyTypesToFormT);
var CUSTOMISE_PAGE_INDEX = 1;
function Assets() {
  var _useStrategyInfo = (0,useStrategyInfo/* useStrategyInfo */.R0)(),
      strategyType = _useStrategyInfo.strategyType;

  var stepsConfig = getSteps(strategyType);

  var _useBalances = (0,useBalances/* default */.Z)(),
      balances = _useBalances.balances;

  var _useValidation = (0,useValidation/* default */.Z)(DcaInFormData/* assetsFormSchema */.yL, {
    balances: balances
  }),
      validate = _useValidation.validate;

  var _useAssetsForm = (0,useDcaInForm/* useAssetsForm */.Vg)(),
      state = _useAssetsForm.state,
      actions = _useAssetsForm.actions;

  var router = (0,next_router.useRouter)();

  var _usePairs = (0,usePairs/* default */.ZP)(),
      pairs = _usePairs.pairs;

  var onSubmit = function onSubmit(formData) {
    var formName = strategyTypesToFormTypes[formData.strategyType];
    actions.updateAction(formName)(formData);
    var currentSteps = getSteps(formData.strategyType);
    (0,routerPush/* routerPush */.J)(router, currentSteps[CUSTOMISE_PAGE_INDEX].href);
  };

  if (!pairs) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWrapper/* ModalWrapper */.A, {
      stepsConfig: stepsConfig,
      reset: actions.resetAction,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
        h: 56,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
      })
    });
  }

  var initialValues = AssetsPageAndForm_objectSpread(AssetsPageAndForm_objectSpread({}, state.step1), {}, {
    strategyType: strategyType,
    initialDenom: state.step1.initialDenom,
    resultingDenom: state.step1.resultingDenom
  });

  return (
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0,jsx_runtime.jsx)(dist/* BrowserRouter */.VK, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        validate: validate,
        onSubmit: onSubmit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWrapper/* ModalWrapper */.A, {
          reset: actions.resetAction,
          stepsConfig: stepsConfig,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
            autoComplete: "off",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_DFWC5MHP/* FormControl */.NI, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryAndStrategyButtonSelectors, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZHMYA64R/* Stack */.K, {
              direction: "column",
              spacing: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AssetsForm, {})
            })]
          })
        })
      })
    })
  );
}

/***/ }),

/***/ 8609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Autostaking; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71293);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function Autostaking() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    textStyle: "body",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: "CALC proudly removes the hassle of needing to manually stake your assets after every swap, otherwise we wouldn't truly be a complete set-and-forget solution. All you need to do is choose the validator of your choice and CALC will take care of the rest."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: "CALC even uses the AuthZ module which means the assets are staked on YOUR behalf in YOUR wallet. You will see the balance staked to your wallet after every swap."
    })]
  });
}

/***/ }),

/***/ 10278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ OutperformProbability; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32883);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49289);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27239);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function OutperformProbability() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    spacing: 8,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
      textStyle: "body",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: "Outperform probability refers to the likelihood of DCA+ delivering better returns than traditional DCA over a given period of time."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: "Given the strategy and the volatility of the cryptocurrency market, longer timeframes produce a higher likelihood of a better performance."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: "We recommend at least 90 days to get the most out of DCA+."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: ["Want to get technical? You can read the whitepaper here:", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
          href: "https://calculated.fi/dca-plus-wp",
          isExternal: true,
          children: "https://calculated.fi/dca-plus-wp"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .i, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
        h: 267,
        src: "/images/outperformProbability.svg",
        alt: "outperform probabliity"
      })
    })]
  });
}

/***/ }),

/***/ 11434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SwapMultiplierHelp; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97702);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32883);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65028);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27239);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48783);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function SwapMultiplierHelp() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    spacing: 8,
    textAlign: "justify",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
      textStyle: "body",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: ["The purpose of this multiplier is to give more", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Tooltip */ .u, {
          label: " \"Weight\" refers to the importance or significance given to different factors or components. Swaps with higher weights will have a greater impact on the final outcome, while swaps with lower weights will have less influence.",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
            color: "grey.200",
            as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r,
            children: ["weight", ' ']
          })
        }), "to swaps that are deemed more favorable and less weight to swaps that are considered less favorable."]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Spacer */ .L, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Center */ .M, {
        p: 2,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .g, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, {
            h: 267,
            src: "/images/swap-multiplier-help.jpg",
            alt: "swap multiplier",
            boxSize: "auto",
            w: "80%"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
            fontSize: "xs",
            textAlign: "center",
            children: "A degen once said, \"price good: ape more, price bad: ape less\"."
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Spacer */ .L, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: "The swap amount is determined through a linear transformation process. It involves assigning a numerical value or score to each swap based on the asset price at the time of the swap."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        fontStyle: "italic",
        children: "The more aggressive the swap multiplier, the more weight price changes will have on the swap."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        children: "By using the swap multiplier in this way, we aim to help users make swaps (buys or sells) at a more favorable price."
      })]
    })
  });
}

/***/ }),

/***/ 75141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dcaIn; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 2 modules
var chunk_ZHMYA64R = __webpack_require__(55281);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var chunk_2OOHT3W5 = __webpack_require__(71293);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-46CXQZ4E.mjs
var chunk_46CXQZ4E = __webpack_require__(73804);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-K7XRJ7NL.mjs
var chunk_K7XRJ7NL = __webpack_require__(32883);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/helpContent/RecurringDeposits.tsx



function RecurringDeposits() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
    textStyle: "body",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
      children: "We don't support this yet but it is on the roadmap and will be CALC's next development focus to create a true, end-to-end DeFi experience."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
      children: "CALC is focused on ease of use and knows that recurring payments are part of a complete set-and-forget strategy. At the moment, we are waiting for the Axelar team to push the General Message Passing module to production and for Kado money to support recurring payments. Once that is ready, we will integrate with Kado Money and allow you to set up recurring payments directly from your bank account to CALC, automatically."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
      children: ["This is estimated to be Q4 2023 but may happen sooner. Please follow", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_K7XRJ7NL/* Link */.r, {
        isExternal: true,
        href: "https://twitter.com/CALC_Finance",
        children: "@CALC_finance"
      }), ' ', "on Twitter to stay up to date."]
    })]
  });
}
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/components/helpContent/Autostaking.tsx
var Autostaking = __webpack_require__(8609);
;// CONCATENATED MODULE: ./src/formConfig/dcaIn.tsx






var dcaInSteps = [{
  href: '/create-strategy/dca-in/assets',
  title: constants/* contentData.dcaIn.assets.title */.fS.dcaIn.assets.title,
  footerText: constants/* contentData.dcaIn.assets.footerText */.fS.dcaIn.assets.footerText,
  helpContent: /*#__PURE__*/(0,jsx_runtime.jsx)(RecurringDeposits, {})
}, {
  href: '/create-strategy/dca-in/customise',
  title: constants/* contentData.dcaIn.customise.title */.fS.dcaIn.customise.title,
  footerText: 'What are advanced settings?',
  helpContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
    textStyle: "body",
    spacing: 2,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
      children: "Advanced features offer you the following functionality:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* OrderedList */.GS, {
      spacing: 1,
      pb: 2,
      pl: 4,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* ListItem */.HC, {
        children: ["Start based on time.", /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* UnorderedList */.QI, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: "Choose a date and time in the future and when that time is hit, the strategy will begin to execute."
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* ListItem */.HC, {
        children: ["Start based on price.", /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* UnorderedList */.QI, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: "Choose a price target and when the price is hit, the strategy will begin to execute"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* ListItem */.HC, {
        children: ["Set buy price ceiling (for DCA In) or price floor (for DCA Out)", /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* UnorderedList */.QI, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: "CALC will not execute swaps if the price of the asset you are accumulating is higher (price ceiling on DCA in) than the price you set in this field or lower (price floors on DCA out)."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: "You can only set a price floor for DCA in and a price floor for DCA out."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: ["For example, If the price ceiling is set to $2.00 on a USK ", '-->', " KUJI DCA out strategy and the KUJI price rises above $2.00 the swaps that are scheduled to happen will be skipped and your strategy will extend an interval. These skips will continue until the price drops below the price ceiling."]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_46CXQZ4E/* ListItem */.HC, {
        children: ["Set slippage tolerance", /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* UnorderedList */.QI, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_46CXQZ4E/* ListItem */.HC, {
            children: "If the slippage exceeds your tolerance, the swap will fail, be skipped for that increment and your strategy length will increase by 1 increment. This is automatically set to 2%, but you can change it to anything you like between 0% and 100%. You can see if a strategy failed because of slippage on the \u201Cview performance\u201D page of each strategy."
          })
        })]
      })]
    })]
  })
}, {
  href: '/create-strategy/dca-in/post-purchase',
  title: 'Post Purchase',
  footerText: 'How does auto staking work?',
  helpContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Autostaking/* Autostaking */.P, {})
}, {
  href: '/create-strategy/dca-in/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/dca-in/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];
/* harmony default export */ var dcaIn = (dcaInSteps);

/***/ }),

/***/ 73860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32883);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73804);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var dcaOutSteps = [{
  href: '/create-strategy/dca-out/assets',
  title: 'Choose Funding & Assets',
  footerText: 'How does taking profit into fiat work?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    textStyle: "body",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: "We don't support this yet but it is on the roadmap and will be CALC's next development focus to create a true, end-to-end DeFi experience. After the Kado Money integration, you'll be able to create a Kado Money account within CALC, link your bank account and have profits sent directly to your account."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: ["This is estimated to be Q4 2023 but may happen sooner. Please follow", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
        isExternal: true,
        href: "https://twitter.com/CALC_Finance",
        children: "@CALC_finance"
      }), ' ', "on Twitter to stay up to date."]
    })]
  })
}, {
  href: '/create-strategy/dca-out/customise',
  title: 'Customise Strategy',
  footerText: 'What are advanced settings?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    textStyle: "body",
    spacing: 2,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: "Advanced features offer you the following functionality:"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .OrderedList */ .GS, {
      spacing: 1,
      pb: 2,
      pl: 4,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
        children: ["Start based on time.", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .UnorderedList */ .QI, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: "Choose a date and time in the future and when that time is hit, the strategy will begin to execute."
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
        children: ["Start based on price.", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .UnorderedList */ .QI, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: "Choose a price target and when the price is hit, the strategy will begin to execute"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
        children: ["Set buy price ceiling (for DCA In) or price floor (for DCA Out)", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .UnorderedList */ .QI, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: "CALC will not execute swaps if the price of the asset you are accumulating is higher (price ceiling on DCA in) than the price you set in this field or lower (price floors on DCA out)."
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: "You can only set a price floor for DCA in and a price floor for DCA out."
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: ["For example, If the price ceiling is set to $2.00 on a USK ", '-->', " KUJI DCA out strategy and the KUJI price rises above $2.00 the swaps that are scheduled to happen will be skipped and your strategy will extend an interval. These skips will continue until the price drops below the price ceiling."]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
        children: ["Set slippage tolerance", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .UnorderedList */ .QI, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: "If the slippage exceeds your tolerance, the swap will fail, be skipped for that increment and your strategy length will increase by 1 increment. This is automatically set to 2%, but you can change it to anything you like between 0% and 100%. You can see if a strategy failed because of slippage on the \u201Cview performance\u201D page of each strategy."
          })
        })]
      })]
    })]
  })
}, {
  href: '/create-strategy/dca-out/post-purchase',
  title: 'Post Purchase',
  footerText: 'What will I be able to do with my profits in the future?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .K, {
    textStyle: "body",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
      children: "CALC is all about automation and we know that flexibility with your assets is key to an amazing product. A few things that you can expect to be added to this strategy set-up flow are reinvesting, moving to other yield generation strategies like providing liquidity and, even sending directly to your bank account when the KADO integration is completed."
    })
  })
}, {
  href: '/create-strategy/dca-out/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/dca-out/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (dcaOutSteps);

/***/ }),

/***/ 17120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ dcaPlusInSteps; }
/* harmony export */ });
/* harmony import */ var _components_helpContent_Autostaking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8609);
/* harmony import */ var _components_helpContent_OutperformProbability__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10278);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18459);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var dcaPlusInSteps = [{
  href: '/create-strategy/dca-plus-in/assets',
  title: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .contentData.dcaIn.assets.title */ .fS.dcaIn.assets.title
}, {
  href: '/create-strategy/dca-plus-in/customise',
  title: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .contentData.dcaIn.customise.title */ .fS.dcaIn.customise.title,
  footerText: 'What does outperform probability mean?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_helpContent_OutperformProbability__WEBPACK_IMPORTED_MODULE_1__/* .OutperformProbability */ .k, {})
}, {
  href: '/create-strategy/dca-plus-in/post-purchase',
  title: 'Post Purchase',
  footerText: 'How does auto staking work?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_helpContent_Autostaking__WEBPACK_IMPORTED_MODULE_0__/* .Autostaking */ .P, {})
}, {
  href: '/create-strategy/dca-plus-in/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/dca-plus-in/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];

/***/ }),

/***/ 39706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71293);
/* harmony import */ var _components_helpContent_OutperformProbability__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10278);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var dcaPlusOutSteps = [{
  href: '/create-strategy/dca-plus-out/assets',
  title: 'Choose Funding & Assets'
}, {
  href: '/create-strategy/dca-plus-out/customise',
  title: 'Customise Strategy',
  footerText: 'What does outperform probability mean?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_helpContent_OutperformProbability__WEBPACK_IMPORTED_MODULE_0__/* .OutperformProbability */ .k, {})
}, {
  href: '/create-strategy/dca-plus-out/post-purchase',
  title: 'Post Purchase',
  footerText: 'What will I be able to do with my profits in the future?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .K, {
    textStyle: "body",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
      children: "CALC is all about automation and we know that flexibility with your assets is key to an amazing product. A few things that you can expect to be added to this strategy set-up flow are reinvesting, moving to other yield generation strategies like providing liquidity and, even sending directly to your bank account when the KADO integration is completed."
    })
  })
}, {
  href: '/create-strategy/dca-plus-out/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/dca-plus-out/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (dcaPlusOutSteps);

/***/ }),

/***/ 2248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18459);

var simpleDcaInSteps = [{
  href: '/',
  title: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .contentData.dcaIn.assets.title */ .fS.dcaIn.assets.title
}, {
  href: '/',
  title: 'Strategy Created!',
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (simpleDcaInSteps);

/***/ }),

/***/ 37154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18459);

var streamingSwapSteps = [{
  href: '/create-strategy/streaming-swap/assets',
  title: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .contentData.streamingSwap.assets.title */ .fS.streamingSwap.assets.title
}, {
  href: '/create-strategy/streaming-swap/success',
  title: 'Swap Started Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (streamingSwapSteps);

/***/ }),

/***/ 79359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ weightedScaleInSteps; }
/* harmony export */ });
/* harmony import */ var _components_helpContent_Autostaking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8609);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18459);
/* harmony import */ var _components_helpContent_SwapMultiplierHelp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11434);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var weightedScaleInSteps = [{
  href: '/create-strategy/weighted-scale-in/assets',
  title: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .contentData.dcaIn.assets.title */ .fS.dcaIn.assets.title
}, {
  href: '/create-strategy/weighted-scale-in/customise',
  title: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .contentData.dcaIn.customise.title */ .fS.dcaIn.customise.title,
  footerText: 'How does the swap multiplier work?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_helpContent_SwapMultiplierHelp__WEBPACK_IMPORTED_MODULE_2__/* .SwapMultiplierHelp */ .i, {})
}, {
  href: '/create-strategy/weighted-scale-in/post-purchase',
  title: 'Post Purchase',
  footerText: 'How does auto staking work?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_helpContent_Autostaking__WEBPACK_IMPORTED_MODULE_0__/* .Autostaking */ .P, {})
}, {
  href: '/create-strategy/weighted-scale-in/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/weighted-scale-in/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];

/***/ }),

/***/ 34010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71293);
/* harmony import */ var _components_helpContent_SwapMultiplierHelp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11434);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var weightedScaleOutSteps = [{
  href: '/create-strategy/weighted-scale-out/assets',
  title: 'Choose Funding & Assets'
}, {
  href: '/create-strategy/weighted-scale-out/customise',
  title: 'Customise Strategy',
  footerText: 'How does the swap multiplier work?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_helpContent_SwapMultiplierHelp__WEBPACK_IMPORTED_MODULE_0__/* .SwapMultiplierHelp */ .i, {})
}, {
  href: '/create-strategy/weighted-scale-out/post-purchase',
  title: 'Post Purchase',
  footerText: 'What will I be able to do with my profits in the future?',
  helpContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .K, {
    textStyle: "body",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
      children: "CALC is all about automation and we know that flexibility with your assets is key to an amazing product. A few things that you can expect to be added to this strategy set-up flow are reinvesting, moving to other yield generation strategies like providing liquidity and, even sending directly to your bank account when the KADO integration is completed."
    })
  })
}, {
  href: '/create-strategy/weighted-scale-out/confirm-purchase',
  title: 'Confirm & Sign'
}, {
  href: '/create-strategy/weighted-scale-out/success',
  title: 'Strategy Set Successfully',
  noBackButton: true,
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (weightedScaleOutSteps);

/***/ }),

/***/ 41393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QL": function() { return /* binding */ getFormState; },
/* harmony export */   "Vg": function() { return /* binding */ useAssetsForm; },
/* harmony export */   "eK": function() { return /* binding */ useDcaInCustomiseForm; },
/* harmony export */   "jK": function() { return /* binding */ useDcaInFormPostPurchase; },
/* harmony export */   "p": function() { return /* binding */ useDcaInConfirmForm; }
/* harmony export */ });
/* unused harmony export useDcaInForm */
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89601);
/* harmony import */ var _hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47134);
/* harmony import */ var _hooks_useFormStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48403);
/* harmony import */ var _hooks_useWallet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5403);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getFormState = function getFormState(state, formName) {
  return state[formName] || {};
};
var useAssetsForm = function useAssetsForm() {
  var _useStrategyInfo = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__/* .useStrategyInfo */ .R0)(),
      formName = _useStrategyInfo.formName;

  var _useWallet = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_4__/* .useWallet */ .O)(),
      address = _useWallet.address;

  var _useFormStore = (0,_hooks_useFormStore__WEBPACK_IMPORTED_MODULE_3__/* .useFormStore */ .V)(),
      state = _useFormStore.forms,
      _updateAction = _useFormStore.updateForm,
      resetAction = _useFormStore.resetForm;

  try {
    return {
      state: {
        step1: _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .assetsFormSchema.validateSync */ .yL.validateSync(getFormState(state, formName), {
          stripUnknown: true
        })
      },
      actions: {
        updateAction: function updateAction(currentFormName) {
          return _updateAction(currentFormName, address);
        },
        resetAction: resetAction(formName)
      }
    };
  } catch (e) {
    return {
      state: {
        step1: _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .assetsFormSchema.cast */ .yL.cast(_models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .assetsFormInitialValues */ .ry, {
          stripUnknown: true
        })
      },
      actions: {
        updateAction: function updateAction(currentFormName) {
          return _updateAction(currentFormName, address);
        },
        resetAction: resetAction(formName)
      }
    };
  }
};
var useDcaInForm = function useDcaInForm() {
  var _useStrategyInfo2 = useStrategyInfo(),
      formName = _useStrategyInfo2.formName;

  var _useWallet2 = useWallet(),
      address = _useWallet2.address;

  var _useFormStore2 = useFormStore(),
      state = _useFormStore2.forms,
      updateAction = _useFormStore2.updateForm,
      resetAction = _useFormStore2.resetForm;

  try {
    return {
      state: {
        step1: step1ValidationSchema.validateSync(getFormState(state, formName), {
          stripUnknown: true
        })
      },
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  } catch (e) {
    return {
      state: {
        step1: step1ValidationSchema.cast(initialValues, {
          stripUnknown: true
        })
      },
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  }
};
var useDcaInCustomiseForm = function useDcaInCustomiseForm() {
  var _useFormStore3 = (0,_hooks_useFormStore__WEBPACK_IMPORTED_MODULE_3__/* .useFormStore */ .V)(),
      state = _useFormStore3.forms,
      updateAction = _useFormStore3.updateForm,
      resetAction = _useFormStore3.resetForm;

  var _useWallet3 = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_4__/* .useWallet */ .O)(),
      address = _useWallet3.address;

  var _useStrategyInfo3 = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__/* .useStrategyInfo */ .R0)(),
      formName = _useStrategyInfo3.formName;

  try {
    var step1 = _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .step1ValidationSchema.validateSync */ .Qg.validateSync(getFormState(state, formName), {
      stripUnknown: true
    });

    var step2 = _objectSpread(_objectSpread({}, _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .step2ValidationSchema.cast */ .SY.cast(_models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .initialValues */ .Sc, {
      stripUnknown: true
    })), _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .step2ValidationSchema.cast */ .SY.cast(getFormState(state, formName), {
      stripUnknown: true
    }));

    return {
      state: {
        step1: step1,
        step2: step2
      },
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  } catch (e) {
    return {
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  }
};
var useDcaInFormPostPurchase = function useDcaInFormPostPurchase() {
  var _useFormStore4 = (0,_hooks_useFormStore__WEBPACK_IMPORTED_MODULE_3__/* .useFormStore */ .V)(),
      state = _useFormStore4.forms,
      updateAction = _useFormStore4.updateForm,
      resetAction = _useFormStore4.resetForm;

  var _useWallet4 = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_4__/* .useWallet */ .O)(),
      address = _useWallet4.address;

  var _useStrategyInfo4 = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__/* .useStrategyInfo */ .R0)(),
      formName = _useStrategyInfo4.formName;

  try {
    return {
      context: _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .step1ValidationSchema.validateSync */ .Qg.validateSync(getFormState(state, formName), {
        stripUnknown: true
      }),
      state: _objectSpread(_objectSpread({}, _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .postPurchaseValidationSchema.cast */ .D0.cast(_models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .initialValues */ .Sc, {
        stripUnknown: true
      })), _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .postPurchaseValidationSchema.cast */ .D0.cast(getFormState(state, formName), {
        stripUnknown: true
      })),
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  } catch (e) {
    return {
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  }
};
var useDcaInConfirmForm = function useDcaInConfirmForm() {
  var _useFormStore5 = (0,_hooks_useFormStore__WEBPACK_IMPORTED_MODULE_3__/* .useFormStore */ .V)(),
      state = _useFormStore5.forms,
      updateAction = _useFormStore5.updateForm,
      resetAction = _useFormStore5.resetForm;

  var _useStrategyInfo5 = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__/* .useStrategyInfo */ .R0)(),
      formName = _useStrategyInfo5.formName;

  var _useWallet5 = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_4__/* .useWallet */ .O)(),
      address = _useWallet5.address;

  try {
    _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .dcaSchema.validateSync */ .rL.validateSync(getFormState(state, formName), {
      stripUnknown: true
    });
    return {
      state: _models_DcaInFormData__WEBPACK_IMPORTED_MODULE_1__/* .dcaSchema.validateSync */ .rL.validateSync(getFormState(state, formName), {
        stripUnknown: true
      }),
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      }
    };
  } catch (e) {
    return {
      actions: {
        updateAction: updateAction(formName, address),
        resetAction: resetAction(formName)
      },
      errors: e
    };
  }
};

/***/ }),

/***/ 9397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89250);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99658);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97719);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34050);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46596);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2749);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function useQueryState() {
  var navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useNavigate */ .s0)();

  var _useLocation = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)(),
      search = _useLocation.search;

  var setQueryParam = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function (value) {
    var overwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return navigate({
      search: query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].stringify */ .Z.stringify((0,rambda__WEBPACK_IMPORTED_MODULE_4__/* .reject */ .d)((0,rambda__WEBPACK_IMPORTED_MODULE_5__/* .either */ .w)(rambda__WEBPACK_IMPORTED_MODULE_6__/* .isNil */ .k, rambda__WEBPACK_IMPORTED_MODULE_7__/* .isEmpty */ .x), _objectSpread(_objectSpread({}, overwrite ? {} : query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(search)), value)))
    });
  }, [search]);
  return [query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(search), setQueryParam];
}

/* harmony default export */ __webpack_exports__["Z"] = (useQueryState);

/***/ }),

/***/ 17987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getBaseDenom; },
/* harmony export */   "v": function() { return /* binding */ getQuoteDenom; }
/* harmony export */ });
var getBaseDenom = function getBaseDenom(pair) {
  return pair.denoms[0];
};
var getQuoteDenom = function getQuoteDenom(pair) {
  return pair.denoms[1];
};

/***/ }),

/***/ 32354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ max; }
/* harmony export */ });
function max(x, y){
  if (arguments.length === 1) return _y => max(x, _y)

  return y > x ? y : x
}


/***/ }),

/***/ 73804:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ OrderedList; },
/* harmony export */   "HC": function() { return /* binding */ ListItem; },
/* harmony export */   "QI": function() { return /* binding */ UnorderedList; }
/* harmony export */ });
/* unused harmony exports useListStyles, List, ListIcon */
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36948);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55227);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92495);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22548);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/list.tsx
;




var [ListStylesProvider, useListStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `ListStylesContext`,
  errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
});
var List = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function List2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("List", props);
  const {
    children,
    styleType = "none",
    stylePosition,
    spacing,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__/* .getValidChildren */ .W)(children);
  const selector = "& > *:not(style) ~ *:not(style)";
  const spacingStyle = spacing ? { [selector]: { mt: spacing } } : {};
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListStylesProvider, { value: styles, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .chakra.ul */ .m.ul,
    {
      ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: { ...styles.container, ...spacingStyle },
      ...rest,
      children: validChildren
    }
  ) });
});
List.displayName = "List";
var OrderedList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)((props, ref) => {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, { ref, as: "ol", styleType: "decimal", marginStart: "1em", ...rest });
});
OrderedList.displayName = "OrderedList";
var UnorderedList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function UnorderedList2(props, ref) {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, { ref, as: "ul", styleType: "initial", marginStart: "1em", ...rest });
});
UnorderedList.displayName = "UnorderedList";
var ListItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function ListItem2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .chakra.li */ .m.li, { ref, ...props, __css: styles.item });
});
ListItem.displayName = "ListItem";
var ListIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function ListIcon2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, { ref, role: "presentation", ...props, __css: styles.icon });
});
ListIcon.displayName = "ListIcon";


//# sourceMappingURL=chunk-46CXQZ4E.mjs.map

/***/ }),

/***/ 5674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SimpleGrid; }
/* harmony export */ });
/* harmony import */ var _chunk_JARCRF6W_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79078);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48940);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7634);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33951);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;

// src/simple-grid.tsx



var SimpleGrid = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function SimpleGrid2(props, ref) {
    const { columns, spacingX, spacingY, spacing, minChildWidth, ...rest } = props;
    const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    const templateColumns = minChildWidth ? widthToColumns(minChildWidth, theme) : countToColumns(columns);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _chunk_JARCRF6W_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Grid */ .r,
      {
        ref,
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        templateColumns,
        ...rest
      }
    );
  }
);
SimpleGrid.displayName = "SimpleGrid";
function toPx(n) {
  return typeof n === "number" ? `${n}px` : n;
}
function widthToColumns(width, theme) {
  return (0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_4__/* .mapResponsive */ .XQ)(width, (value) => {
    const _value = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .getToken */ .LP)("sizes", value, toPx(value))(theme);
    return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
  });
}
function countToColumns(count) {
  return (0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_4__/* .mapResponsive */ .XQ)(
    count,
    (value) => value === null ? null : `repeat(${value}, minmax(0, 1fr))`
  );
}


//# sourceMappingURL=chunk-NEK3OOAM.mjs.map

/***/ })

}]);